module.exports = __webpack_public_path__ + "static/media/HAYThere-logo.b569ca31.svg";